import React from 'react';
import PropTypes from 'prop-types';
import FollowButton from '../../shared/follow-button';
import Loading from '../../../shared/loading';
import defaultOnErrorHandler from '../../../shared/default-on-error-handler';
import { useFollow, useUnfollow } from '../../../services/stock-codes/follow-service';
import OnboardingContext from '../common/context';

export default function OnboardingProductFollowButton({ stockCodeSlug, followed }) {
  const { dispatch } = React.useContext(OnboardingContext);
  const [{ loading: followLoading }, follow] = useFollow();
  const [{ loading: unfollowLoading }, unfollow] = useUnfollow();
  const loadingRef = React.useRef();

  React.useEffect(() => {
    if (followLoading || unfollowLoading) {
      loadingRef.current.start();
    }
  }, [followLoading, unfollowLoading]);

  const action = followed ? unfollow : follow;
  const type = followed ? 'setUnfollow' : 'setFollow';
  const verb = followed ? 'unfollowing' : 'following';

  const toggle = () => {
    loadingRef.current.start({
      onFadeInComplete: () => {
        action(stockCodeSlug)
          .then(() => dispatch({ type, payload: stockCodeSlug }))
          .catch(err => defaultOnErrorHandler(err, `Error ${verb} this stock code`));
      },
    });
  };

  return (
    <Loading ref={loadingRef} variant="button">
      <FollowButton followed={followed} onToggle={toggle} />
    </Loading>
  );
}

OnboardingProductFollowButton.propTypes = {
  stockCodeSlug: PropTypes.string.isRequired,
  followed: PropTypes.bool.isRequired,
};
